import Pin from 'components/Pin';
import styles from './Waypoint.module.scss';
import { ReactComponent as DragIcon } from 'assets/drag.svg';
import Text from 'components/Text/Text';

interface IWaypointCard {
    waypoint: any
    index: number 
    arriveTime: string
}

const WaypointCard = ({ waypoint, index, arriveTime}: IWaypointCard) => {
  return (
      <div className={styles.waypointCard}>
        <div className={styles.waypointCardContent}>
          <DragIcon/>
          <Pin width={25} height={25} total={index} />
          <div className={styles.column}>
            <Text>{arriveTime}</Text>
            <Text>Time</Text>
          </div>
          <div className={styles.column}>
            <Text>15:00</Text>
            <Text>Length</Text>
          </div>
          <p>{waypoint.practitionerName}</p>
        </div>
        {waypoint.travelTime ? (
          <div className={styles.waypointCardFooter}>
            <p>Travel Time: {waypoint.travelTime + ' minutes'}</p>
          </div>
        ) : <></>}
      </div>
  )
}

export default WaypointCard;